import { ConnectedCartIcon as CartIcon } from 'tenants/cccsyd/cart_icon';
import Logout from 'tenants/cccsyd/auth/logout';
import AvailabilityQuickView from 'ecom-engine-react/components/availability_quick_view';
import AvailabilitySearch from 'ecom-engine-react/components/availability_search';

export default {
  CartIcon,
  Logout,
  AvailabilityQuickView,
  AvailabilitySearch,
};
